angular.module('dentalLinks')

.constant('USER_ROLES', {
        admin: {id: 'admin', name: 'Admin', desc: 'Administrator', mask: 1},
        doctor: {id: 'doctor', name: 'Doctor', desc: 'Dental Services Provider', mask: 2},
        aux: {id: 'aux', name: 'Aux',desc: 'Auxiliary', mask: 4},
        super: {id: 'super', name: 'Super', desc: 'Super User', mask: 8},
        public: {id: 'public', name: 'Public', desc: 'Public Access', mask: 16}
})

.constant('FREE_TRIAL_PERIOD', 30)
.constant('HTTP_ERROR_EVENTS', {
    requestTimeout: 'http-request-timeout',
    serverError: 'http-server-error'
})
.constant('API_ENDPOINT', window.env.api_endpoint)
.constant('SITE_URL', window.env.site_url)
.constant('ENVIRONMENT_NAME', window.env.environment_name)
.constant('PATIENT_PORTAL_HOST', window.env.patient_portal_host || '')
.constant('AUTH_EVENTS', {
    notAuthenticated: 'auth-not-authenticated',
    forbidden: 'forbidden',
    paymentRequired: 'payment-required'
})

// Premium features list, shared by the upgrade modal (UpgradeModalController) and
// the Plan & usage page (InsightsController) so both surfaces stay in sync. These mirror the features actually granted on the Premium plan by the
// backend (see subscription_service.rb#features_for_plan) and the tier definitions
// in docs/design/subscription-tiers.md. We only list features that are available
// now — post-launch items (AI post-op notes, 3+ practice collaboration) are
// intentionally omitted. Note: data retention is 3 years on every tier, so it
// does not belong here.
//
// `key` is the Plan & usage page's section name for that feature (DCL-592), used
// by the ?section= links from Account Settings. `specialistOnly` hides a feature
// from general dentists, who already get it on Basic. `blockedHeadline` marks a
// feature a Premium gate can name (the `feature` of a 402, or of a paymentRequired
// broadcast, which is its `key`), so the upgrade modal can lead with it (DCL-645).
.constant('PREMIUM_FEATURES', [
    {
        key: 'incoming_referrals',
        specialistOnly: true,
        icon: 'fas fa-infinity',
        title: 'Unlimited Incoming Referrals',
        // DCL-592: Basic is a soft paywall, so nothing is ever held back. What
        // Premium changes is the monthly allowance and its notices.
        description: 'No monthly allowance or Premium notices. On Basic, every referral still arrives in full'
    },
    {
        key: 'locations',
        blockedHeadline: 'Adding another location requires Premium',
        icon: 'fas fa-map-marker-alt',
        title: 'Unlimited Locations',
        description: 'Add every practice location — Basic includes one'
    },
    {
        key: 'providers',
        blockedHeadline: 'Adding another provider requires Premium',
        icon: 'fas fa-user-md',
        title: 'Unlimited Providers',
        description: 'Add every doctor in your practice — Basic includes one'
    },
    {
        key: 'custom_link',
        icon: 'fas fa-code',
        title: 'Custom Website Integration',
        description: 'Add a referral form to your website and accept referrals from any practice'
    },
    {
        key: 'branding',
        icon: 'fas fa-palette',
        title: 'Custom Branding',
        description: 'Show your practice logo and brand on referrals'
    },
    {
        key: 'qr_code',
        icon: 'fas fa-qrcode',
        title: 'QR Code on Referral PDFs',
        description: 'PDFs you print include a QR code linking to the destination practice\'s website'
    },
    {
        key: 'cbct',
        blockedHeadline: 'Attaching CBCT scans requires Premium on either practice',
        icon: 'fas fa-cube',
        title: 'CBCT Scan Sharing',
        // DCL-523: one subscription unlocks scan transfer for both practices on
        // a referral, so this reads as a benefit the subscriber's referral
        // partners get too — not something both sides have to buy. Viewing a scan
        // is free on every plan (DCL-510), so only attaching is claimed here.
        description: 'Attach CBCT scans to referrals — with any practice you work with, whatever their plan'
    },
    {
        key: 'patient_portal',
        icon: 'fas fa-envelope-open-text',
        title: 'Patient Communication Portal',
        description: 'Securely send referrals to patients and get forms signed'
    },
    {
        key: 'priority_support',
        icon: 'fas fa-headset',
        title: 'Priority Support',
        description: 'Dedicated support when you need it'
    }
])

.run(['$rootScope', '$injector', 'API_ENDPOINT', 'SITE_URL', 'ENVIRONMENT_NAME', 'PATIENT_PORTAL_HOST', 'AUTH_EVENTS', function($rootScope, $injector, API_ENDPOINT, SITE_URL, ENVIRONMENT_NAME, PATIENT_PORTAL_HOST, AUTH_EVENTS) {
    $rootScope.DATETIME = window.env.datetime;
    $rootScope.CURRENT_YEAR = window.env.current_year;
    $rootScope.API_ENDPOINT = API_ENDPOINT;
    $rootScope.SITE_URL = SITE_URL;
    $rootScope.ENVIRONMENT_NAME = ENVIRONMENT_NAME;
    $rootScope.PATIENT_PORTAL_HOST = PATIENT_PORTAL_HOST;

    // Handle 402 Payment Required responses by showing the upgrade modal
    $rootScope.$on(AUTH_EVENTS.paymentRequired, function(event, data) {
        // Use $injector to avoid circular dependency with $uibModal
        $injector.get('UpgradeModal').open(data);
    });
}])

.config(['$stateProvider', '$urlRouterProvider', 'USER_ROLES', '$provide', function ($stateProvider, $urlRouterProvider, USER_ROLES, $provide) {
    $stateProvider.
        state('signIn', {
            url: '/sign_in',
            params: {invalidToken: false, pid: false},
            templateUrl: 'partials/login.html',
            controller: 'LoginController'
        }).
        state('guestOrLogin', {
            url: '/guest_or_login?pid',
            templateUrl: 'partials/guest_or_login.html',
            controller: 'GuestOrLoginController'
        }).
        state('pre_registration', {
            url: '/register',
            templateUrl: 'partials/pre_registration.html',
            controller: 'PreRegistrationController'
        }).
        state('pre_registration_confirmation', {
            url: '/register_confirmation',
            templateUrl: 'partials/pre_registration_confirmation.html',
            controller: 'PreRegistrationConfirmationController'
        }).
        state('registration', {  // self-registration also comes here, but invitation.inviter_id is missing then
            url: '/register/:invitation_token',
            templateUrl: 'partials/registration.html',
            controller: 'RegistrationController'
        }).
        state('guest_conversion', {
            url: '/register/guest_conversion/:conversion_token',
            templateUrl: 'partials/registration.html',
            controller: 'RegistrationController'
        }).
        state('error_page', {
            url: '/error/:error_key',
            templateUrl: 'partials/error.html',
            controller: 'ErrorController'
        }).
        state('createGuestReferral', {
            url: '/create_guest_referral?pid',
            templateUrl: 'partials/create_guest_referral.html',
            controller: 'CreateGuestReferralsController',
        }).
        state('createReferral', {
            url: '/create_referral?pid',
            templateUrl: 'partials/create_referral.html',
            controller: 'CreateReferralsController',
            reloadOnSearch: false,
            resolve: {
                authGuard: 'CreateReferralGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('reviewReferral', {
            url: '/create_referral/:referral_id',
            params: {message: null},
            templateUrl: 'partials/create_referral.html',
            controller: 'ReviewReferralsController',
            resolve: {
                authGuard: 'StandardUserGuard',
                currentReferral: ['$q', '$stateParams', '$state', 'Referral', function ($q, $stateParams, $state, Referral) {
                    var d = $q.defer();
                    Referral.get({id: $stateParams.referral_id}).$promise.then(function (referral) {
                        if ('draft' == referral.status) {
                            d.resolve(referral); //allow controller instantiation and passing currentReferral to controller as a parameter
                        } else {
                            d.reject('redirect_to_viewReferral'); //prevent controller instantiation and emit $stateChangeError event for redirecting to viewReferral state
                        }

                    }).catch(function(error){
                        if(error.status === 422) {
                            $state.go('error_page', {error_key: error.data.message});
                        }
                    });
                    return d.promise;
                }
                ],
            message: ['$stateParams', function($stateParams){
                return $stateParams.message;
            }]},
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('logout', {
            url: '/logout',
            templateUrl: 'partials/login.html',
            controller: 'LoginController'
        }).
        // linked from login page
        // on submission calls Password.reset()
        // => POST /password (endpoint provided by devise_for and passwords_controller.rb)
        // => sends out an email message, which will then allow user to save new password
        state('resetPassword', {
            url: '/reset_password',
            templateUrl: 'partials/reset_password.html',
            controller: 'PasswordsController'
        }).
        // linked from `reset_password` email templates
        // if token is correct, then email address ownership is confirmed
        // user is retrieved using token
        state('resetPasswordToken', {
            url: '/edit_password/:reset_password_token',
            templateUrl: 'partials/edit_password.html',
            controller: 'PasswordsController'
        }).
        state('addPassword', {
            url: '/add_password/:add_password_token',
            templateUrl: 'partials/add_password.html',
            controller: 'SavePasswordController'
        }).
        state('viewReferral', {
            url: '/view_referral/:referral_id',
            params: {message: null, isNew: false},
            templateUrl: 'partials/view_referral.html',
            controller: 'ViewReferralsController',
            resolve: {
                authGuard: 'StandardUserGuard',
                message: ['$stateParams', function($stateParams){
                    return $stateParams.message;
                }]
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('history', {
            url: '/history?query&start&end&status',
            templateUrl: 'partials/history.html',
            controller: 'HistoryController',
            reloadOnSearch: false,
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        // DCL-592: the Plan & usage page. `src` says which link brought the visitor
        // (DCL-532 reads it), `section` which feature to scroll to.
        state('insights', {
            url: '/insights?src&section',
            templateUrl: 'partials/insights.html',
            controller: 'InsightsController',
            reloadOnSearch: false,
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin', {
            url: '/admin',
            templateUrl: 'partials/admin.html',
            controller: 'AdminController',
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin.practice', {
            url: '/practice',
            templateUrl: 'partials/admin_practice.html',
            controller: 'AdminPracticeController',
            // Search params (?subscription from Stripe, ?upgrade deep link) are consumed
            // and cleared by the controller; a reload on that change would re-instantiate
            // the controller and dismiss the upgrade dialog mid-open (DCL-443).
            reloadOnSearch: false,
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin.users', {
            url: '/users',
            templateUrl: 'partials/admin_users.html',
            controller: 'AdminUsersController',
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin.users.notifications', {
            url: '/notifications',
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin.invite', {
            url: '/invite',
            templateUrl: 'partials/admin_invite.html',
            controller: 'AdminInviteController',
            resolve: {
                authGuard: 'StandardUserGuard'
            },
            access: [USER_ROLES.doctor, USER_ROLES.admin, USER_ROLES.aux]
        }).
        state('admin.support', {
            url: '/support',
            templateUrl: 'partials/support.html',
            controller: 'SupportController'
        }).
        state('console', {
            abstract: true,
            url: '/console',
            templateUrl: 'partials/console.html',
            controller: 'ConsoleController'
        }).
        state('console.practice', {
            url: '/practice?practice&user&invitation',
            templateUrl: 'partials/console_practice.html',
            controller: 'PracticeConsoleController',
            reloadOnSearch: false,
            resolve: {
                authGuard: 'SuperUserGuard'
            },
            access: [USER_ROLES.super]
        }).
        state('console.reports', {
            url: '/reports?tab',
            templateUrl: 'partials/console_reports.html',
            controller: 'ReportsConsoleController',
            reloadOnSearch: false,
            resolve: {
                authGuard: 'SuperUserGuard'
            },
            access: [USER_ROLES.super]
        }).
        state('activity', {
            url: '/activity',
            templateUrl: 'partials/activity.html',
            controller: 'ActivityController'
        }).
        state('license', {
            url: '/license',
            templateUrl: 'partials/license.html'
        }).
        state('confirmEmail', {
            url: '/confirm_email/:token',
            template: '',
            controller: 'ConfirmEmailController'
        }).
        state('unsubscribe', {
            url: '/unsubscribe?md_id',
            templateUrl: 'partials/unsubscribe.html',
            controller: 'UnsubscribeController'
        }).
        state('activateGuestReferral', {
            url: '/activate_guest_referral?activation_token',
            template: '',
            controller: 'ActivateGuestReferralController'
        }).
        state('guestReferralActivated', {
            url: '/guest_referral_activated',
            params: {referral: null},
            templateUrl: 'partials/guest_referral_activated.html',
            controller: 'GuestReferralActivatedController'
        }).
        state('offerConvertGuest', {
            url: '/offer_convert_guest',
            templateUrl: 'partials/offer_convert_guest.html',
            controller: 'OfferConvertGuestController',
        }).

        state('debug', {
            url: '/debug',
            templateUrl: 'partials/debug.html'
        });

        $urlRouterProvider.otherwise('/sign_in');

        $provide.decorator('$exceptionHandler', ['$delegate', '$injector', '$window', function($delegate, $injector, $window) {
            return function (exception, cause) {  // cause is undefined sometimes, since it's optional
                // Filter out authentication guard rejections - these are expected behavior, not errors
                var exceptionMessage = exception && exception.message ? exception.message : String(exception);
                var blacklistedError = exceptionMessage.includes('Not authenticated');
                
                if ($window.Rollbar && !blacklistedError) {
                    $window.Rollbar.error(exception, {cause: cause}, function(err, data) {
                        var $rootScope = $injector.get('$rootScope');
                        $rootScope.$emit('rollbar:exception', {
                            exception: exception,
                            err: err,
                            data: data?.result
                        });
                    });
                }
                $delegate(exception, cause);
            };
        }]);

        $provide.decorator('$uibModal', ['$delegate', function ($delegate) {
            var originalOpen = $delegate.open;

            $delegate.open = function (options) {
                // Default backdrop to 'static' if not specified
                if (options && options.backdrop === undefined) {
                    options.backdrop = 'static';
                }
                return originalOpen(options);
            };

            return $delegate;
        }]);
    }])

    .run(['$rootScope', '$window', '$location', '$state', '$transitions', 'redirect', 'Auth', 'AUTH_EVENTS', 'UnsavedChanges', 'ModalHandler', '$uibModal', 'Logger', 'CustomBranding', 'BrandingSettings', function ($rootScope, $window, $location, $state, $transitions, redirect, Auth, AUTH_EVENTS, UnsavedChanges, ModalHandler, $uibModal, Logger, CustomBranding, BrandingSettings) {

        if(CustomBranding.get()) {
            CustomBranding.apply(CustomBranding.get());
        } else {
            CustomBranding.remove();
        }

        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            ModalHandler.dismissIfOpen();  // close dialog if open, when going back/forward in browser history.
            if (!Auth.authorize(toState.access)) {
                event.preventDefault();
                $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, {redirect: $location.url(), params: $location.search()});
            }
            if ($location.search().pid){
                BrandingSettings.get({pid: $location.search().pid}, function(branding){
                    if(branding.id){
                        CustomBranding.apply({pidBased: true, settings: branding.ui_data });
                    }
                })
            }
        });

        $rootScope.$on('$stateChangeSuccess',function(event){
                if (!$window.ga)
                    return;

                $window.ga('send', 'pageview', { page: $location.path() });
            });

        $rootScope.$on(AUTH_EVENTS.notAuthenticated, function (event, args) {
            Auth.remove();

            redirect.path = args.redirect;

            if (args && args.params && args.params.pid) {
                $state.go('guestOrLogin', args.params, {reload: true});
            } else {
                $state.go('signIn', args.params, {reload: true});
            }
        });

        $rootScope.$on(AUTH_EVENTS.forbidden, function(event, args){
            Logger.log('forbidden');
            $state.go('error_page', {error_key: 'access.denied'});
        });
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            // Under ui-router 1.x the polyfill passes a Rejection object; the string
            // sentinel lives in its `detail` (comparing the object itself never matches).
            if(error == 'redirect_to_viewReferral' || (error && error.detail == 'redirect_to_viewReferral')){
                $state.go('viewReferral', toParams);
            }
        });

        // Reload persistence (DCL-440): a draft created on the Create Referral screen
        // is recorded in sessionStorage (see CreateReferralsController). A reload lands
        // back on createReferral with the key still set — retarget the transition to
        // reviewReferral before any template or controller instantiates. Deliberate
        // in-app navigation away clears the key, so a later Create Referral visit
        // starts fresh (the draft stays reachable from History).
        $transitions.onBefore({to: 'createReferral'}, function (transition) {
            var draftKey = 'dcl.createDraft.' + (transition.params().pid || 'default');
            var storedDraftId = $window.sessionStorage.getItem(draftKey);
            if (storedDraftId) {
                $window.sessionStorage.removeItem(draftKey);
                return transition.router.stateService.target('reviewReferral', {referral_id: storedDraftId}, {location: 'replace'});
            }
        });
        $transitions.onSuccess({from: 'createReferral'}, function (transition) {
            var draftKey = 'dcl.createDraft.' + (transition.params('from').pid || 'default');
            $window.sessionStorage.removeItem(draftKey);
        });
        UnsavedChanges.init();
    }])

.value('redirect', {path: '/history'})

.config(['$locationProvider', '$qProvider', function ($locationProvider, $qProvider) {
    $locationProvider.hashPrefix('!'); // ensure '#!/...' works everywhere

    /*$locationProvider.html5Mode(true);*/ //doesn't work without server-side url rewriting, to return on every request only the entrypoint page (like index.html)
    // Prevent noisy "Possibly unhandled rejection" console errors.
    // We handle auth and other HTTP errors centrally via interceptors and UI.
    if ($qProvider && typeof $qProvider.errorOnUnhandledRejections === 'function') {
        $qProvider.errorOnUnhandledRejections(false);
    }
}])

.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.withCredentials = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $httpProvider.interceptors.push('authInterceptor');
    $httpProvider.interceptors.push('spinnerInterceptor');
    $httpProvider.interceptors.push('errorsHttpInterceptor');
    $httpProvider.interceptors.push('requestNotificationInterceptor');
}
])

.factory('spinnerInterceptor', ['$q', 'Spinner', function ($q, Spinner) {
    return {
        request: function (config) {
            // do something on success
            if(!config.skipSpinner){
                Spinner.show();
            }
            return config;
        },

        requestError: function (rejection) {
            if(!rejection.config.skipSpinner){
                Spinner.hide();
            }
            return $q.reject(rejection);
        },

        response: function (response) {
            if(!response.config.skipSpinner){
                Spinner.hide();
            }
            return response;
        },

        responseError: function (rejection) {
            if(!rejection.config.skipSpinner){
                Spinner.hide();
            }
            return $q.reject(rejection);
        }
    };
}])

.factory('errorsHttpInterceptor', ['$rootScope', '$q', '$injector', 'HTTP_ERROR_EVENTS', function($rootScope, $q, $injector, HTTP_ERROR_EVENTS){
    return {
        requestError: function(rejection){
            $rootScope.$broadcast(HTTP_ERROR_EVENTS.requestError, {status: rejection.status, text: rejection.statusText});

            Rollbar.error(
                "NetworkError: Failed request: " + rejection.config.url + "\n" +
                "method: " + rejection.config.method + "\n" +
                "status: " + rejection.status + "\n" +
                "statusText: " + rejection.statusText + "\n");

            return $q.reject(rejection);
        },
        responseError: function(rejection){
            if(rejection.status == 0) {
                $rootScope.$broadcast(HTTP_ERROR_EVENTS.requestTimeout,
                    {status: rejection.status, text: 'http.request.timeout'});
            } else if(rejection.status == 408) {
                $rootScope.$broadcast(HTTP_ERROR_EVENTS.requestTimeout,
                    {status: rejection.status, text: rejection.statusText});
            } else if(rejection.status >= 503 && rejection.status < 504){
                $rootScope.$broadcast(HTTP_ERROR_EVENTS.serverError,
                    {status: rejection.status, text: rejection.statusText});
            }

            if(!(rejection.status == 401 || rejection.status == 422) && (rejection.status < 300 || rejection.status > 399)){
                Rollbar.error(
                    "NetworkError: Failed response: " + rejection.config.url + "\n" +
                    "method: " + rejection.config.method + "\n" +
                    "status: " + rejection.status + "\n" +
                    "statusText: " + rejection.statusText + "\n");
            }

            return $q.reject(rejection);
        }
    };
}])

.factory('requestNotificationInterceptor', ['$rootScope', '$q', 'Notification', function ($rootScope, $q, Notification) {
    return {
        request: function (config) {
            Notification.close();
            return config;
        },

        requestError: function (rejection) {
            Notification.close();
            return $q.reject(rejection);
        }
    };
}])

.filter('filterUsersByRole', function() {
    return function(inputArray, mask) {
        if (!inputArray) {
            return false;
        }
        return inputArray.filter(function(user) {
            if (user.id == -1) {
                return true;
            }
            return user.roles_mask & mask;
        });
    };
})
    
.filter('filterUsersByAddress', function() {
   return function(inputArray, addressId) {
        if (!inputArray) {
            return false;
        }
        return inputArray.filter(function(item) {
            if (item.id == -1) {
                return true;
            }
            for (var i = 0; i < item.addresses.length; i++) {
                if (item.addresses[i].id === addressId) {
                    return true;
                }
            }
            return false;
        });
    };
})

.filter('filename', function () {
    return function (fullFileName) {
        return fullFileName.slice(fullFileName.lastIndexOf('/') + 1);
    }
})

.filter('money', function () {
    return function (centsAmount) {
        return centsAmount / 100;
    }
})

.filter('viewAttachmentUrl', ['API_ENDPOINT', function(API_ENDPOINT){
   return function(attachment){
       return API_ENDPOINT + '/attachment/?file=' + attachment.id + '/' + attachment.attach_file_name;
   }
}])

.filter('viewAuthenticatableAttachmentUrl', ['API_ENDPOINT', function(API_ENDPOINT){
    return function(attachment){
        return API_ENDPOINT + '/attachment/?file=' + attachment.id + '/' + attachment.attach_file_name;
    }
}])

.filter('attachmentDownloadUrl', ['API_ENDPOINT', function(API_ENDPOINT){
    return function(attachment){
        return API_ENDPOINT + '/attachment/?file=' + attachment.id + '/' + attachment.attach_file_name + "&download=true";
    }
}]);

